import React from 'react';
import ModalItem from '../Modal';
import UploadFile from '../UploadFile';
import MiniSpinner from '../MiniSpinner';
import { getFormatoExcel } from '../../../api/axios';
import { toast } from '../../../utilities/appToast';
import { base64ToBlob, saveByteArrayXlsx } from '../../../utilities/formatFile';

const nombresPorTipo = {
  1: 'Modelo Actualización Precio-Stock',
  2: 'Modelo Actualización Masiva Imágenes',
  3: 'Modelo Actualización TipoPub-Envio',
  4: 'Modelo Creación Masiva de Publicaciones'
};

export default function CardActualizacionMasiva({
  title = 'Actualizar',
  btnText = 'Actualizar',
  isLoading = false,
  updateFile,
  exportExcel,
  isValidUpdateExcel,
  additionalHeader = undefined,
  children,
  tipoExcel = 1,                 
  downloadName,
  acceptType,
  fileInputLabel
}) {
  const isCsvTemplate = [1, 2, 3, 4].includes(Number(tipoExcel));
  const resolvedAcceptType = acceptType ?? (isCsvTemplate ? '.csv' : '.xls, .xlsx');
  const resolvedFileInputLabel =
    fileInputLabel ?? (isCsvTemplate ? 'Seleccionar archivo CSV:' : 'Seleccionar archivo excel:');

  const descargarExcel = async () => {
    try {
      const { data } = await getFormatoExcel({ tipoExcel });

      let b64 =
        data.excel ??
        data.archivoBase64 ??
        data.base64 ??
        (typeof data === 'string' ? data : '');

      if (!b64) throw new Error('Respuesta sin base64');

      const comma = b64.indexOf(',');
      if (comma !== -1) b64 = b64.slice(comma + 1);
      b64 = b64.replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4 !== 0) b64 += '=';

      const blob = base64ToBlob(b64, isCsvTemplate ? 'text/csv;charset=utf-8;' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

      // prioriza: downloadName -> title -> nombre por tipo -> fallback
      const baseName = downloadName || title || nombresPorTipo[tipoExcel] || 'Modelo';
      const fileName = isCsvTemplate
        ? (baseName.endsWith('.csv') ? baseName : `${baseName}.csv`)
        : (baseName.endsWith('.xlsx') ? baseName : `${baseName}.xlsx`);

      saveByteArrayXlsx(fileName, blob);
    } catch (e) {
      console.error(e);
      toast.error('No se pudo descargar el archivo.');
    }
  };

  return (
    <div className="row align-items-center">
      <div className="col-12 col-md-auto mt-2">
        <h6><strong>{title}</strong></h6>
      </div>

      <div className="col-12 col-md-auto">
        <button className="btn btn-sm btn-green" type="button" onClick={descargarExcel}>
          {isCsvTemplate ? 'Descargar CSV' : 'Formato Excel'}
        </button>
      </div>

      {additionalHeader && <div className="col-12 col-md-auto">{additionalHeader}</div>}

      <div className="col-12 my-3">
        <div className="row">
          <div className="col-12"><label>{resolvedFileInputLabel}</label></div>
          <div className="col-auto col-md-12 text-md-center">
            <UploadFile acceptType={resolvedAcceptType} inputId={title} onFileLoaded={updateFile} />
          </div>
        </div>
      </div>

      {children}

      <div className="form-horizontal form-material p-10">
        <div className="tab-content">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-sm-auto" hidden={!isLoading}><MiniSpinner /></div>
            <div className="col-12 col-sm-auto px-2">
              <ModalItem
                text={`¿${btnText}?`}
                disabled={isLoading}
                onDelete={exportExcel}
                validationHandler={isValidUpdateExcel}
                btnText={btnText}
                btnStyle="btn btn-sm background-rojo-megatone waves-light"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
